export default {
  stages: [],
  stage_plannings: {
    results: [],
  },
}
